import { render, staticRenderFns } from "./oneCancellatioBoxes.vue?vue&type=template&id=77771da3&scoped=true&"
import script from "./oneCancellatioBoxes.vue?vue&type=script&lang=js&"
export * from "./oneCancellatioBoxes.vue?vue&type=script&lang=js&"
import style0 from "./oneCancellatioBoxes.vue?vue&type=style&index=0&id=77771da3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77771da3",
  null
  
)

export default component.exports